var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login-div" } }, [
    _c("h1", { staticClass: "page-title mt-2" }, [
      _vm._v("\n      " + _vm._s(_vm.$t("preloginTitle")) + "\n    ")
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "content mt-3" }, [
      _vm._v("\n      " + _vm._s(_vm.$t("preloginSubtitle")) + "\n    ")
    ]),
    _vm._v(" "),
    _vm.form.isEmailValid.value === null
      ? _c(
          "form",
          {
            staticClass: "mt-4",
            on: {
              submit: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.handleIsEmailValid.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "b-alert",
              {
                attrs: { show: _vm.ui.showError, variant: "danger" },
                on: {
                  "update:show": function($event) {
                    return _vm.$set(_vm.ui, "showError", $event)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.ui.showErrorMessage) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("loginFirstCredential"),
                  "label-for": "username-input"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "username-input",
                    type: "email",
                    placeholder: "email.utilisateur@email.fr",
                    required: ""
                  },
                  model: {
                    value: _vm.form.username.value,
                    callback: function($$v) {
                      _vm.$set(_vm.form.username, "value", $$v)
                    },
                    expression: "form.username.value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn-block",
                    attrs: { type: "submit", variant: "primary" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "span",
                          { staticClass: "align-self-center mt-small-px" },
                          [_vm._v(_vm._s(_vm.$t("Next")))]
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a986989", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a986989","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/RedirectLoginSignUp.vue
// module id = cj24
// module chunks = 0